export const FEATURE_VIDEO = 'video';
export const FEATURE_SOUND = 'sound';
export const FEATURE_RECORD_SOUND = 'record_sound';
export const FEATURE_CALL = 'call';
export const LOCAL_VIDEO_CONTAINER_NAME = 'mine-video-window';
export const REMOTE_VIDEO_CONTAINER_NAME = 'main-video-window';
